import styles from './PoleEducation2.module.css'
import PoleEducation2Image from '../../../../assets/images/poleeducation2.png'

const PoleEducation2 = () => (
  <>
    <header className={styles.header}>
      <div className={styles.imageContainer}>
        <img
          src={PoleEducation2Image}
          alt="Pôle Éducation"
          className={styles.headerImage}
        />
      </div>
    </header>
  </>
)

export default PoleEducation2
